import { render, staticRenderFns } from "./UpdateEmailOverlay.vue?vue&type=template&id=157d97d2&scoped=true"
import script from "./UpdateEmailOverlay.vue?vue&type=script&lang=js"
export * from "./UpdateEmailOverlay.vue?vue&type=script&lang=js"
import style0 from "./UpdateEmailOverlay.vue?vue&type=style&index=0&id=157d97d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157d97d2",
  null
  
)

export default component.exports